import { render, staticRenderFns } from "./IssueDocumentAsideActions.vue?vue&type=template&id=04f68a1c&scoped=true"
import script from "./IssueDocumentAsideActions.vue?vue&type=script&lang=ts"
export * from "./IssueDocumentAsideActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f68a1c",
  null
  
)

export default component.exports